// extracted by mini-css-extract-plugin
module.exports = {"tab":"periodSelector_tab__EBgiD","left":"periodSelector_left__5E5PS","right":"periodSelector_right__ABqlI","selected":"periodSelector_selected__deGkk"};